import * as React from 'react';
import { Button } from '@cian/ui-kit/button';
import OtpInput from 'react-otp-input';
import { ERROR_MAP, OTP_INPUT_STYLES, OTP_INPUT_FOCUSED_STYLES, OPT_INPUT_DISABLED_STYLES } from './const';
import { useSecondsLeft } from './hook';

import * as style from './styles.css';

interface IOtpForm {
  otp: string;
  error: string;
  setOtp(code: string): void;
  sendOtp(code: string): void;
  resendOtp(): void;
}

export const OtpForm: React.FC<IOtpForm> = ({ otp, error, setOtp, sendOtp, resendOtp }) => {
  const { seconds, reset } = useSecondsLeft(30);

  const sendOtpCode = React.useCallback(() => {
    sendOtp(otp);
  }, [sendOtp, otp]);

  const resendOtpCode = React.useCallback(() => {
    resendOtp();
    reset();
  }, [reset, resendOtp]);

  return (
    <div className={style['container']}>
      <div className={style['digits']}>
        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={4}
          isInputNum
          shouldAutoFocus
          isDisabled={false}
          inputStyle={OTP_INPUT_STYLES}
          focusStyle={OTP_INPUT_FOCUSED_STYLES}
          disabledStyle={OPT_INPUT_DISABLED_STYLES}
        />
        {error && <span className={style['error']}>{ERROR_MAP[error]}</span>}
      </div>
      <div className={style['footer']}>
        <span className={style['send-button']}>
          <Button fullWidth size="M" disabled={otp.length < 4} onClick={sendOtpCode}>
            Подтвердить
          </Button>
        </span>
        <Button
          size="M"
          theme="fill_white_primary"
          disabled={seconds > 0}
          onClick={resendOtpCode}
          // Ошибка в ui-kit, фон должен быть transparent
          // @ts-ignore
          style={{
            background: 'transparent',
          }}
        >
          Прислать код еще раз {seconds > 0 ? `(${seconds})` : ''}
        </Button>
      </div>
    </div>
  );
};
